import ReturnArrow from '../../src/legacy/ReturnArrow';
export default ReturnArrow;
